<template>
  <div
    class="app-container"
  >
    <Container
      :title="t('pay.paymentDetail')"
      :hasLine="false"
      style="height: 360px; overflow: auto;"
    >
      <template #main>
        <SimpleTableForEdit
          ref="tableRef"
          :listLoading="listLoading"
          :tableData="tableData"
          :columnStruct="columnStruct"
          :hadSelect="false"
          :operateColumnWidth="255"
          @custom-event="handleEditEvent"
        >
          <template
            #default="slotProps"
          >
            <div
              v-if="hasAcceptancePayment(slotProps.row)"
              class="acceptanceContainer"
            >
              <i
                style="font-size: 30px; color:#098905;"
                class="el-icon-success"
              />
              <span>{{ t('pay.HasAcceptancePayment') }}</span>
            </div>
            <div v-else>
              <el-button
                :disabled="(slotProps.row.subId !== undefined && slotProps.row.subId !== null) || hasSubAcceptancePayment(slotProps.row)"
                @click="handleDelete(slotProps.row.id)"
                type="danger"
                size="mini"
              >
                {{ t('pay.Remove') }}
              </el-button>
              <el-button
                v-if="slotProps.row.isSub === false"
                @click="handleSlipt(slotProps.row)"
                type="primary"
                size="mini"
                style="width: 80px;"
              >
                {{ t('pay.Splitting') }}
              </el-button>
              <el-button
                v-else
                @click="handleCancelSlipt(slotProps.row)"
                :disabled="hasSubAcceptancePayment(slotProps.row)"
                type="primary"
                size="mini"
                style="width: 80px;"
              >
                {{ t('pay.CancelSplitting') }}
              </el-button>
              <el-button
                @click="handleAcceptancePayment(slotProps.row)"
                type="primary"
                size="mini"
                :disabled="!(slotProps.row.isSub === false)"
              >
                {{ t('pay.AcceptancePayment') }}
              </el-button>
            </div>
          </template>
        </SimpleTableForEdit>
      </template>
    </Container>
  </div>
  <div
    class="app-container"
  >
    <Container
      :title="t('pay.cashStatusSimulation')"
      :hasLine="false"
      style="height: calc(100vh - 575px); min-height: 340px; overflow-x: auto; white-space: nowrap;"
    >
      <template #main>
        <PaymentSlipCharts
          :key="'PaymentSlipChart' + index"
          v-for="(item, index) in chartsData"
          :id="'PaymentSlipChart' + index"
          :chartInfo="item.chartInfo"
          :chartData="item.chartData"
          :company="company"
        />
        <div class="fixed-bottom-button">
          <el-button
            type="primary"
            @click="handleShowTotalAmount"
          >
            {{ t('pay.showTotalAmount') }}
          </el-button>
          <el-button
            type="primary"
            @click="availableAcceptanceDialogVisible = true"
          >
            {{ t('pay.CheckAcceptancePayment') }}
          </el-button>
          <el-button
            type="primary"
            @click="handleSubmit"
          >
            {{ t('pay.InsertPaymentBuffer') }}
          </el-button>
        </div>
      </template>
    </Container>
    <PaymentSelectCompanyDialog
      v-if="selectCompanyDialogVisible"
      v-model="selectCompanyDialogVisible"
      :dataId="dataId"
      :isSub="isSub"
      :companyCode="companyCode"
      :companyBankId="companyBankId"
      @refresh="onDialogConfirm"
    />
    <PaymentSelectVendorBankDialog
      v-if="selectVendorBankDialogVisible"
      v-model="selectVendorBankDialogVisible"
      :dataId="dataId"
      :isSub="isSub"
      :vendorNumber="vendorNumber"
      :vendorBankAccount="vendorBankAccount"
      :vendorBankCode="vendorBankCode"
      :vendorBankName="vendorBankName"
      @refresh="onDialogConfirm"
    />
    <PaymentSlipWorkDialog
      v-if="paymentSlipWorkDialogVisible"
      v-model="paymentSlipWorkDialogVisible"
      :dataId="dataId"
      :isSub="isSub"
      :workData="workData"
      @refresh="onDialogConfirm"
    />
    <PaymentCancelSlipWorkDialog
      v-if="paymentCancelSlipWorkDialogVisible"
      v-model="paymentCancelSlipWorkDialogVisible"
      :dataId="dataId"
      :workData="workData"
      @refresh="onDialogConfirm"
    />
    <AvailableAcceptanceDialog
      v-if="availableAcceptanceDialogVisible"
      v-model="availableAcceptanceDialogVisible"
    />
    <AcceptancePaymentDialog
      v-if="acceptancePaymentDialogVisible"
      v-model="acceptancePaymentDialogVisible"
      :dataId="dataId"
      :isSub="isSub"
      :workData="workData"
      @refresh="onDialogConfirm"
    />
    <BaseDialog
      v-if="datePickerDialogVisible"
      v-model="datePickerDialogVisible"
      :title="t('order.setPaymentDate')"
      :autoClose="false"
      width="30%"
      content-center
      destroy-on-close
      @confirm="onDatePickerDialogConfirm"
    >
      <template #default>
        <el-date-picker
          v-model="selectedDate"
          type="date"
          :placeholder="t('common.selectDateTip')"
          :default-value="new Date()"
          :show-time="false"
          size="large"
        />
      </template>
    </BaseDialog>
    <el-dialog
      width="40%"
      v-model="dialogTipVisible"
    >
      <div
        style="text-align: center; padding-bottom: 30px;"
      >
        <i
          class="el-icon-warning icon-warning-expand"
        /><br>
        <span>{{ dialogTip }}</span>
      </div>
      <div
        class="dialog-footer"
        style="text-align: right;"
      >
        <el-button @click="dialogTipVisible = false">
          {{ t('table.cancel') }}
        </el-button>
        <el-button
          type="primary"
          @click="dialogTipType === 0 ? handleDeleteConfirm() : handleSubmitConfirm()"
        >
          {{ t('table.confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      width="40%"
      v-model="totalAmountDialogVisible"
      :title="t('pay.plannedTotalAmountPayable')"
    >
      <SimpleTable
        ref="tableRef"
        :tableData="totalAmountData"
        :columnStruct="totalAmountStruct"
        :hadSelect="false"
        :had-operate="false"
      />
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref, toRefs } from 'vue'
import SimpleTableForEdit from '@/components/table/simple/SimpleTableForEdit.vue'
import Container from '@/components/form/container/Container.vue'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import Decimal from 'decimal.js'
import { formatDate, formatThousands } from '@/utils'
import BaseDialog from '@/components/dialog/BaseDialog.vue'
import {
  PaymentSlipTotalAmountModel, PaymentSlipWorkModel, SlipWorkUpdatePaymentDate
} from '@/model/paymentSlip/paymentSlipModel'
import { CompanyListParamModel } from '@/model/master-data/companyModel'
import {
  getPaymentSlipWorkList, updatePaymentDate, removePaymentSlipWork,
  submitPaymentSlipWork, checkBalance, willSubmitPayment, getPaymentSlipTotalAmount
} from '@/apis/paymentSlip/paymentSlip'
import { getCompanyAllList } from '@/apis/main-data/company'
import PaymentSelectCompanyDialog from '@/views/pay/PaymentSelectCompanyDialog.vue'
import PaymentSelectVendorBankDialog from '@/views/pay/PaymentSelectVendorBankDialog.vue'
import PaymentSlipWorkDialog from '@/views/pay/PaymentSlipWorkDialog.vue'
import PaymentCancelSlipWorkDialog from '@/views/pay/PaymentCancelSlipWorkDialog.vue'
import AvailableAcceptanceDialog from '@/views/pay/AvailableAcceptanceDialog.vue'
import AcceptancePaymentDialog from '@/views/pay/AcceptancePaymentDialog.vue'
import PaymentSlipCharts from '@/views/pay/PaymentSlipCharts.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'

export default defineComponent({
  components: {
    SimpleTable,
    BaseDialog,
    PaymentSelectCompanyDialog,
    PaymentSelectVendorBankDialog,
    PaymentSlipWorkDialog,
    PaymentCancelSlipWorkDialog,
    AvailableAcceptanceDialog,
    AcceptancePaymentDialog,
    PaymentSlipCharts,
    SimpleTableForEdit,
    Container
  },
  methods: {

  },
  setup() {
    const { t } = useI18n()
    const router = useRouter()
    const tableRef = ref()
    const paymentSlipTableStruct = [
      { prop: 'companyCode', label: t('company.companyCode'), width: 90 },
      {
        prop: 'companyBankName',
        label: t('pay.PaymentBank'),
        canEdit: 'true',
        notComplete: (row: any) => (row.status !== 2 && !row.isAccepted && !row.isSub),
        width: 220
      },
      { prop: 'payee', label: t('pay.payee') },
      { prop: 'vendorComment', label: t('pay.vendorComment') },
      {
        prop: 'bankName',
        label: t('pay.ReceivingBank'),
        canEdit: 'true',
        notComplete: (row: any) => (row.status !== 2 && !row.isAccepted && !row.isSub),
        width: 220
      },
      { prop: 'amount', label: t('pay.PaymentAmount'), width: 120, formatter: (row: any) => formatThousands(row.amount), align: 'right' },
      { prop: 'dueDate', label: t('Acceptance.dueDate'), formatter: (row: any) => formatDate(row.dueDate, 'yyyy-MM-dd'), width: 100 },
      {
        prop: 'paymentDate',
        label: t('pay.paymentDay'),
        formatter: (row: any) => formatDate(row.paymentDate, 'yyyy-MM-dd'),
        canEdit: 'true',
        notComplete: (row: any) => (row.status !== 2 && !row.isAccepted && !row.isSub),
        width: 140
      },
      { prop: 'purpose', label: t('pay.purposeView'), width: 170 }
    ]
    const totalAmountTableStruct = [
      { prop: 'companyCode', label: t('company.companyCode') },
      { prop: 'companyBankName', label: t('pay.PaymentBank') },
      { prop: 'totalAmount', label: t('pay.totalAmountPayable'), formatter: (row: any) => formatThousands(row.totalAmount), align: 'right' }
    ]
    const dataMap = reactive({
      tableData: Array<PaymentSlipWorkModel>(),
      slipWork: {} as PaymentSlipWorkModel | null,
      columnStruct: paymentSlipTableStruct,
      totalAmountStruct: totalAmountTableStruct,
      totalAmountData: Array<PaymentSlipTotalAmountModel>(),
      selectCompanyDialogVisible: false,
      selectVendorBankDialogVisible: false,
      paymentSlipWorkDialogVisible: false,
      paymentCancelSlipWorkDialogVisible: false,
      availableAcceptanceDialogVisible: false,
      acceptancePaymentDialogVisible: false,
      totalAmountDialogVisible: false,
      listLoading: true,
      dataId: 0,
      isSub: false,
      companyCode: '',
      companyBankId: 0,
      vendorNumber: '',
      vendorBankAccount: 0,
      vendorBankCode: '',
      vendorBankName: '',
      workData: null,
      datePickerDialogVisible: false,
      selectedDate: null as Date | null,
      dialogTipVisible: false,
      dialogTipType: 0,
      dialogTip: '',
      chartsData: [] as any[],
      company: [] as any[],
      async getTablePageList() {
        dataMap.listLoading = true
        const data = await getPaymentSlipWorkList()
        if (data && data.data && data.data.length > 0) {
          dataMap.tableData = data.data
        } else {
          dataMap.tableData = []
        }
        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      handleEditEvent(row: any, itemProp: string) {
        dataMap.isSub = row.subId !== undefined && row.subId !== null
        dataMap.dataId = dataMap.isSub ? row.subId : row.id
        if (itemProp === 'companyBankName') {
          dataMap.companyCode = row.companyCode
          dataMap.companyBankId = row.companyBank
          dataMap.selectCompanyDialogVisible = true
        } else if (itemProp === 'bankName') {
          dataMap.vendorNumber = row.vendorNumber
          dataMap.vendorBankAccount = row.bankAccount
          dataMap.vendorBankCode = row.bankCode
          dataMap.vendorBankName = row.bankName
          dataMap.selectVendorBankDialogVisible = true
        } else if (itemProp === 'paymentDate') {
          dataMap.selectedDate = null
          dataMap.datePickerDialogVisible = true
        }
      },
      hasAcceptancePayment(row: PaymentSlipWorkModel): boolean {
        if (row.isAccepted) {
          return true
        } else {
          return false
        }
      },
      hasSubAcceptancePayment(row: PaymentSlipWorkModel): boolean {
        if (row.children && row.children.length > 0 && row.children.some((c: any) => c.isAccepted)) {
          return true
        } else {
          return false
        }
      },
      async handleShowTotalAmount() {
        const data = await getPaymentSlipTotalAmount()
        if (data && data.data && data.data.length > 0) {
          dataMap.totalAmountData = data.data
        } else {
          dataMap.tableData = []
        }
        dataMap.totalAmountDialogVisible = true
      }
    })
    const getCompanyList = async() => {
      const params: CompanyListParamModel = {
        name: null,
        companyCode: null
      }
      const data = await getCompanyAllList(params)
      dataMap.company = data?.data ?? []
    }
    const getAcceptanceList = async() => {
      const res = await checkBalance()
      if (res && res.data && res.data.length > 0) {
        const allWorkData: any[] = []
        dataMap.chartsData = []
        dataMap.tableData.forEach(t => {
          if (t.isAccepted) {
            return
          }
          const { children, ...newData } = t
          if (t.isSub && children) {
            allWorkData.push(...children)
          } else {
            allWorkData.push(newData)
          }
        })
        const bufferRes = await willSubmitPayment()
        if (bufferRes && bufferRes.data && bufferRes.data.length > 0) {
          allWorkData.push(...bufferRes.data)
        }
        for (const d of res.data) {
          if (!d.amt) {
            continue
          }
          const chartData: any[] = []
          allWorkData.filter(t => t.companyBank === d.companyBankId).forEach(w => {
            const paymentDateStr = formatDate(w.paymentDate, 'MM-dd')
            const paymentChartData = chartData.find(c => c.xValue === paymentDateStr)
            if (paymentChartData) {
              paymentChartData.yValue = new Decimal(paymentChartData.yValue).plus(new Decimal(w.amount)).toString()
            } else {
              chartData.push({ xValue: paymentDateStr, yValue: w.amount.toString(), sortDate: formatDate(w.paymentDate, 'yyyyMMdd') })
            }
          })
          dataMap.chartsData.push({ chartInfo: d, chartData: chartData.sort((a, b) => a.sortDate.localeCompare(b.sortDate)) })
        }
      }
    }
    const onDialogConfirm = async() => {
      await dataMap.getTablePageList()
      await getAcceptanceList()
    }
    const onDatePickerDialogConfirm = async() => {
      if (dataMap.selectedDate != null) {
        const params: SlipWorkUpdatePaymentDate = {
          isSubWork: dataMap.isSub,
          workId: dataMap.dataId,
          workSubId: dataMap.dataId,
          paymentDate: formatDate(dataMap.selectedDate)
        }
        const res = await updatePaymentDate(params)
        if (res?.data && res?.data > 0) {
          ElMessage({
            message: t('common.setSuccess'),
            type: 'success',
            duration: 2000
          })
          dataMap.datePickerDialogVisible = false
        } else {
          ElMessage({
            message: res?.msg,
            type: 'error',
            duration: 2000
          })
        }
        await dataMap.getTablePageList()
        await getAcceptanceList()
      } else {
        ElMessage({
          message: t('order.setPaymentDateP'),
          type: 'error'
        })
      }
    }
    const handleSlipt = async(row: any) => {
      dataMap.isSub = row.subId !== undefined && row.subId !== null
      dataMap.dataId = dataMap.isSub ? row.subId : row.id
      dataMap.workData = dataMap.isSub ? dataMap.tableData.find(d => d.id === row.paymentSlipWorkId) : row
      dataMap.paymentSlipWorkDialogVisible = true
    }
    const handleCancelSlipt = async(row: any) => {
      dataMap.dataId = row.id
      dataMap.workData = row
      dataMap.paymentCancelSlipWorkDialogVisible = true
    }
    const handleDelete = async(id: number) => {
      dataMap.dataId = id
      dataMap.dialogTipType = 0
      dataMap.dialogTip = t('pay.workPaymentDeleteP')
      dataMap.dialogTipVisible = true
    }
    const handleDeleteConfirm = async() => {
      const res = await removePaymentSlipWork(dataMap.dataId)
      if (res?.data && res?.data > 0) {
        ElMessage({
          message: t('common.operateSuccess'),
          type: 'success',
          duration: 2000
        })
        dataMap.dialogTipVisible = false
        await dataMap.getTablePageList()
        await getAcceptanceList()
      } else {
        ElMessage({
          message: res?.msg,
          type: 'error',
          duration: 2000
        })
      }
    }
    const handleAcceptancePayment = (row: any) => {
      dataMap.isSub = row.subId !== undefined && row.subId !== null
      dataMap.dataId = dataMap.isSub ? row.subId : row.id
      dataMap.workData = row
      dataMap.acceptancePaymentDialogVisible = true
    }
    const handleSubmit = () => {
      const isNotAccepted = dataMap.tableData.filter(value => { return value.isAccepted === false }).length > 0
      if (dataMap.tableData.length > 0 && isNotAccepted) {
        dataMap.dialogTipType = 1
        dataMap.dialogTip = t('pay.workPaymentSubmitP')
        dataMap.dialogTipVisible = true
      } else {
        ElMessage({
          message: t('pay.payListIsEmpty'),
          type: 'error',
          duration: 2000
        })
      }
    }
    const handleSubmitConfirm = async() => {
      const res = await submitPaymentSlipWork()
      if (res?.data && res?.data > 0) {
        ElMessage({
          message: t('common.operateSuccess'),
          type: 'success',
          duration: 2000
        })
        dataMap.dialogTipVisible = false
        await router.push({ path: 'execute', state: { refresh: true } })
      } else {
        ElMessage({
          message: res?.msg,
          type: 'error',
          duration: 2000
        })
      }
    }
    onMounted(() => {
      dataMap.getTablePageList()
      getCompanyList()
      getAcceptanceList()
    })
    return {
      t,
      tableRef,
      onDialogConfirm,
      onDatePickerDialogConfirm,
      handleSlipt,
      handleCancelSlipt,
      handleDelete,
      handleDeleteConfirm,
      handleSubmitConfirm,
      handleSubmit,
      handleAcceptancePayment,
      ...toRefs(dataMap)
    }
  }
})
</script>

<style scoped lang="scss">
.acceptanceContainer {
  display: flex;
  justify-content: center; /* 根据需要选择合适的对齐方式 */
  align-items: center; /* 垂直居中 */
}

.fixed-bottom-button {
  position: fixed;
  text-align: right;
  bottom: 40px; /* 距离底部的距离 */
  right: 20px; /* 距离右边的距离 */
  margin-bottom: 10px;
}
.icon-warning-expand {
  font-size: 40px;
  color:var(--warning-color);
  padding-bottom: 30px;
}
</style>
